// extracted by mini-css-extract-plugin
export default {"growShrink":"WordButton_growShrink__zocz9"};